module.exports = __webpack_public_path__ + "16e78bd074428638aa3c2aa1a4e8a222.svg";